"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _constants = require("../constants");

var _constants2 = require("./constants");

var _helperComponents = require("./helperComponents");

var _propTypes = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["flex", "insetElementLeading", "insetElementTrailing", "margin", "maxWidth", "minWidth", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var InputWithoutDocs = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var flex = _ref.flex,
      insetElementLeading = _ref.insetElementLeading,
      insetElementTrailing = _ref.insetElementTrailing,
      margin = _ref.margin,
      maxWidth = _ref.maxWidth,
      minWidth = _ref.minWidth,
      width = _ref.width,
      inputProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var containerProps = {
    flex: flex,
    margin: margin,
    maxWidth: maxWidth,
    minWidth: minWidth,
    width: width
  };
  var disabled = inputProps.disabled;

  if (!insetElementLeading && !insetElementTrailing) {
    return (0, _core.jsx)(_helperComponents.InputBase, (0, _extends2.default)({}, containerProps, inputProps, {
      ref: ref
    }));
  }

  var leadingConfig = insetElementLeading ? _objectSpread(_objectSpread({}, _constants2.INSET_ELEMENT_DEFAULTS), insetElementLeading) : undefined;
  var trailingConfig = insetElementTrailing ? _objectSpread(_objectSpread({}, _constants2.INSET_ELEMENT_DEFAULTS), insetElementTrailing) : undefined;
  var disabledOffset = disabled ? _constants2.DISABLED_ICON_OFFSET : 0;
  var padding = {
    left: leadingConfig ? leadingConfig.width + leadingConfig.inset * 2 + disabledOffset : // There is an edge case where if *only* trailingConfig is passed, it overrides
    // styles for disabled icon. Passing the default value here makes the override not happen
    _constants.INPUT_PADDING_HORIZONTAL_DEFAULT + disabledOffset,
    right: trailingConfig ? trailingConfig.width + trailingConfig.inset * 2 : undefined
  };
  return (0, _core.jsx)(_helperComponents.PositionRelativeContainer, containerProps, (0, _core.jsx)(_helperComponents.InputBase, (0, _extends2.default)({
    padding: padding,
    width: "100%"
  }, inputProps, {
    ref: ref
  })), leadingConfig && (0, _core.jsx)(_helperComponents.InsetElementContainer, {
    disabled: disabled,
    inset: leadingConfig.inset
  }, leadingConfig.element), trailingConfig && (0, _core.jsx)(_helperComponents.InsetElementContainer, {
    inset: trailingConfig.inset,
    isTrailing: true
  }, trailingConfig.element));
});

var InputWithDocs = (0, _stencilReactDesc.describe)(InputWithoutDocs).description('Form element that accepts text based inputs.');
InputWithDocs.propTypes = _objectSpread(_objectSpread({}, _propTypes.inputBasePropTypes), {}, {
  insetElementLeading: _stencilReactDesc.PropTypes.shape(_propTypes.insetElementShape).description('Element to display inside the input on the leading side.'),
  insetElementTrailing: _stencilReactDesc.PropTypes.shape(_propTypes.insetElementShape).description('Element to display inside the input on the trailing side.')
});
var Input = (0, _utils.withTestAttributes)({
  component: 'StencilInput'
})(InputWithDocs);
Input.displayName = 'Input';
var _default = Input;
exports.default = _default;